import api from '@/api'

class PaymentService {

	static paymentStripe(data, route) {
		return api({
      url: route,
      data,
      method: 'post'
		})
  }

  static paymentPaypal(data, route) {
    return api({
      url: route,
      data,
      method: 'post'
    })
  }

  static paymentMercadoPago(data, route) {
    return api({
      url: route,
      data,
      method: 'post'
    })
  }

  static generateCheckoutMercadoPago(data) {
    return api({
      url: 'generate-preference-mp',
      method: 'post',
      data
    })
  }

  static usedDiscountCode(url, data) {
    return api({
      url: url,
      data,
      method: 'post'
    })
  }

  static calculatedPriceDelivery(data) {
    return api({
      url: 'lalamove/quotation',
      data,
      method: 'post'
    })
  }

}

export default PaymentService
